import React from 'react';

import Wrong from 'shared/ui/icons/General/Wrong';
import Correct from 'shared/ui/icons/General/Correct';
import {brandColor} from 'shared/lib/colors';
import {PALETTE} from 'shared/config/model/palette';

interface IYesNoProps {
    condition: boolean,
    color?: string,
    colorFalse?: string,
}

const YesNo: React.FC<IYesNoProps> = ({condition, color = PALETTE.accent, colorFalse = PALETTE.error}) => {
    return condition ? <Correct color={brandColor(color, PALETTE.success)}/> : <Wrong color={colorFalse}/>;
};

export default YesNo;